import React from "react";

import BottomNavigation, {
    BottomNavigationAction,
} from "material-ui/BottomNavigation";

import MailIcon from "material-ui-icons/Mail";
import LensIcon from "material-ui-icons/Lens";
import Info from "material-ui-icons/Info";
import EuroIcon from "material-ui-icons/EuroSymbol";
import { WithStyles, ListItem } from "material-ui";
import withStyles from "material-ui/styles/withStyles";
import { Link, withRouter } from "react-router-dom";
import { ReduxState, ReduxDispatch } from "ducks/reducers";
import { connect } from "react-redux";
import { getBottomBarTab, SetBottomBarTab } from "ducks/common";
import { RouteComponentProps } from "react-router";
import { getThreads } from "../../ducks/messages";
import {
    MessageThreadDto,
    MessageStatus,
    MessageSender,
} from "../../util/DTOs/MessageDtos";

interface BottomBarProps {}

interface IBottomBarReduxProps {
    currentBottomBarTab: number;
    unreadThreads: boolean;
}

interface IBottomBarDispatchProps {
    setBottomBarTab: (tab: number) => void;
}

const styles = {
    root: {
        background: "#FFF",
        borderTop: "1px solid #EEE",
        zIndex: 1100, // Same as AppBar
    },
};

export const PortfolioTab = 0;
export const MessagesTab = 1;
export const NewsFeedTab = 2;
interface OwnProps extends RouteComponentProps<{}> {}
type BottomBarPropsWithStyles = BottomBarProps &
    IBottomBarDispatchProps &
    IBottomBarReduxProps &
    OwnProps &
    WithStyles<"root">;

class BottomBar extends React.Component<BottomBarPropsWithStyles, {}> {
    handleChange = (event: {}, value: number) => {
        this.props.setBottomBarTab(value);
    };

    render() {
        const { classes } = this.props;

        return (
            <BottomNavigation
                value={this.props.currentBottomBarTab}
                onChange={this.handleChange}
                showLabels
                className={classes.root}
                role="contentinfo"
            >
                <BottomNavigationAction
                    disableRipple
                    label="Varallisuus"
                    icon={<EuroIcon />}
                    className={"icon bottomNavItem"}
                    component={(p) => <Link {...p} to="/" />}
                    onKeyDown={(event) => {
                        if (event.key === "Enter") {
                            this.props.history.push("/");
                        }
                    }}
                />

                <BottomNavigationAction
                    disableRipple
                    label="Viestit"
                    icon={
                        <span>
                            <MailIcon />
                            {this.props.unreadThreads && (
                                <LensIcon
                                    style={{
                                        width: 10,
                                        height: 10,
                                        color: "orange",
                                        position: "absolute",
                                        top: 5,
                                    }}
                                />
                            )}
                        </span>
                    }
                    className={"icon bottomNavItem"}
                    component={(p) => <Link {...p} to="/messages" />}
                    onKeyDown={(event) => {
                        if (event.key === "Enter") {
                            this.props.history.push("/messages");
                        }
                    }}
                />

                <BottomNavigationAction
                    disableRipple
                    label="Uutisvirta"
                    icon={<Info />}
                    className={"icon bottomNavItem"}
                    component={(p) => <Link {...p} to="/newsfeed" />}
                    onKeyDown={(event) => {
                        if (event.key === "Enter") {
                            this.props.history.push("/newsfeed");
                        }
                    }}
                />
            </BottomNavigation>
        );
    }
}

const mapStateToProps = (state: ReduxState): IBottomBarReduxProps => {
    const threads = getThreads(state);
    const threadArr: MessageThreadDto[] = Object.keys(threads).map((key) => {
        return threads[key];
    });

    const unreadThreads = threadArr.some((thr) =>
        thr.messages.some(
            (msg) =>
                msg.status === MessageStatus.New &&
                msg.sender !== MessageSender.Customer
        )
    );

    return {
        currentBottomBarTab: getBottomBarTab(state),
        unreadThreads: unreadThreads,
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IBottomBarDispatchProps => {
    return {
        setBottomBarTab: (tab: number) => {
            dispatch(SetBottomBarTab(tab));
        },
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(BottomBar))
);



// WEBPACK FOOTER //
// ./src/components/BottomBar/BottomBar.tsx